/**
 * 渠道/运行环境判断工具
 * 业务入口可能是：微信小程序 webview、App webview、普通 H5（微信内或外部浏览器）
 *
 * 判断优先级：
 * 1. URL 显式参数 source/channel（跳转方主动声明，最可靠）
 * 2. 运行环境特征判断（兜底，用于跳转方未显式声明的情况）
 */

export const PLATFORM = {
  MINI_PROGRAM: 'miniprogram', // 微信小程序 webview
  APP: 'app',                  // App 内嵌 webview
  H5: 'h5'                     // 普通 H5（微信内直接打开 / 外部浏览器）
}

/**
 * 是否处于微信小程序 webview 环境
 * 微信客户端会在小程序的 webview 里注入 __wxjs_environment
 */
export function isMiniProgramEnv() {
  return window.__wxjs_environment === 'miniprogram'
}

/**
 * 是否处于 App 内嵌 webview 环境
 * 约定：App 端在自定义 UA 中追加标识 "WTBApp"
 * 如果 App 端使用其他标记方式，请同步修改此处判断逻辑
 */
export function isAppEnv() {
  return /WTBApp/i.test(window.navigator.userAgent)
}

/**
 * 获取当前渠道
 * @returns {string} PLATFORM 中的一个值
 */
export function getPlatform() {
  // 1. URL 显式声明优先
  const params = new URLSearchParams(window.location.hash.split('?')[1] || window.location.search)
  const declared = (params.get('source') || params.get('channel') || '').toLowerCase()
  if (declared === PLATFORM.MINI_PROGRAM || declared === PLATFORM.APP || declared === PLATFORM.H5) {
    return declared
  }

  // 2. 环境特征兜底判断
  if (isMiniProgramEnv()) return PLATFORM.MINI_PROGRAM
  if (isAppEnv()) return PLATFORM.APP
  return PLATFORM.H5
}

export function isMiniProgram() {
  return getPlatform() === PLATFORM.MINI_PROGRAM
}

export function isApp() {
  return getPlatform() === PLATFORM.APP
}
